<template>
    <layout-authentication-container>
        <div class="flex py-12 px-8 w-full max-w-lg items-center justify-between flex-col h-full rounded-xl">
            <div class="flex items-center justify-center w-full">
                <img src="@/assets/img/logo.png" @click="$router.push('/')" class="cursor-pointer h-[3.5rem]" alt="">
            </div>
            <div class="flex flex-col h-full gap-8 items-start w-full justify-center">
                <div class="flex flex-col gap-2 w-full items-center">
                    <span class="text-2xl text-gray-700 tracking-wide font-medium">Welcome Back, Mentor</span>
                    <span class="text-xs md:text-sm text-center tracking-wide text-secondary">Ready to help them reach their full potential?</span>
                </div>
                <div class="flex flex-col gap-4 w-full">
                    <div class="w-full flex-col justify-start items-start">
                        <span class="text-sm text-secondary tracking-wide">Email or Username</span>
                        <a-input v-model:value="form.login" placeholder="Email Address, Username" size="large"
                            class="w-full mt-2" />
                        <span v-if="errors.login" class="text-red-500 text-xs mt-2 tracking-wide">{{ errors.login }}</span>
                    </div>
                    <div class="w-full flex-col justify-start items-start">
                        <span class="text-sm text-secondary tracking-wide">Password</span>
                        <a-input-password v-model:value="form.password" placeholder="Enter your password" type="password"
                            size="large" class="w-full mt-2" />
                        <span v-if="errors.password" class="text-red-500 text-xs mt-2 tracking-wide">{{ errors.password
                        }}</span>
                    </div>
                </div>
                <span @click="$router.push('/Forgot/Request')"
                    class="text-primary cursor-pointer text-sm font-normal tracking-wide">Forgot Password?</span>

                <a-button :loading="isLoading" @click="onClickSignin" class="w-full" type="primary" size="large">Sign In</a-button>

                <div class="w-full justify-center items-center flex-col">
                    <div class="w-full justify-center gap-1 tracking-wide items-center flex mt-2">
                        <span class="text-sm text-secondary w-3/4 md:w-auto">Do you want to login as Social Enterprise?</span>
                        <span @click="$router.push('/SignIn')"
                            class="text-primary cursor-pointer text-sm font-normal w-1/4 text-center md:w-auto md:text-start">Sign In</span>
                    </div>
                </div>
            </div>
        </div>
    </layout-authentication-container>
</template>

<script setup>
import { onMounted, ref, watch } from "vue"
import { message } from 'ant-design-vue';
import AuthApi from "../../api/auth"
import Cookies from 'js-cookie';
import useAuth from "@/composables/useAuth"
import { useOneSignal } from "@onesignal/onesignal-vue3";

const isLoading = ref(false)
const authApi = new AuthApi()

const form = ref({
    login: '',
    password: ''
})

const errors = ref({
    login: '',
    password: ''
})

// Watch for changes in the form to clear errors
watch(() => form.value.login, (newValue) => {
    if (newValue) {
        errors.value.login = '';
    }
});

watch(() => form.value.password, (newValue) => {
    if (newValue) {
        errors.value.password = '';
    }
});

onMounted(() => {
    document.addEventListener('keypress', handleKeyPress)
})


const handleKeyPress = (event) => {
  if (event.key === 'Enter') {
    onClickSignin()
  }
}

// Validate form fields
const validateForm = () => {
    errors.value.login = form.value.login ? '' : 'Email or Username is required.'
    errors.value.password = form.value.password ? '' : 'Password is required.'
    return !errors.value.login && !errors.value.password
}

const getProfile = async (token) => {
    try {
        const r = await authApi.getMentorProfile()
        if (!r.data) {
            message.error("Failed to fetch profile")
            return;
        }
        useAuth().set(JSON.stringify(r.data), useAuth().get().token, true, true)

        const redirectTo = sessionStorage.getItem('redirectAfterLogin') || '/Mentor/Internal/Core';
        sessionStorage.removeItem('redirectAfterLogin');
        
        const user = JSON.parse(JSON.parse(useAuth().get().user));

        // await useOneSignal().Slidedown.promptPush();
        
        // await useOneSignal().login(user.email);

        // await useOneSignal().User.addTags({
        //     'type':  'mentor', 
        //     'email': user.email, 
        //     'name': user.name
        // });
        
        setTimeout(() => {
            window.location.href = redirectTo;
        }, 1000);
    } catch (error) {
        message.error(error?.response?.data?.message ?? 'An error occurred. Please try again later.')
    }
}

const onClickSignin = async () => {
    let successLogin = false;

    if (validateForm()) {
        isLoading.value = true
        try {
            const response = await authApi.mentorLogin(form.value)
            if (!response) return false
            useAuth().set(null, response?.data?.access_token, false, true) 
            successLogin = true

        } catch (error) {
            const errorResponse = error?.response?.data;
            useAuth().set(null, errorResponse?.access_token, false, true);
            // if (errorResponse.unverified === 2) {
            //     window.location.href = "/Verify/Whatsapp?pre=true"
            //     return
            // }

            message.error(errorResponse?.message ?? 'An error occurred. Please try again later.')
        } finally {
            isLoading.value = false
        }
    }

    if (!successLogin) return;

    try {
        await getProfile();
    } catch (error) {
        console.error('Error during sign in (Get Profile):', error);
    } finally {
        isLoading.value = false
    }
}

</script>
